import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const ForeignInvoiceDetail = React.lazy(() => import('../components/ForeignInvoiceDetail'));
function ForeignInvoiceDetailView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <ForeignInvoiceDetail {...props} />
    </Suspense>
  );
}

export default ForeignInvoiceDetailView;
